class savePurchasingAccountsController {

  constructor(modalLoaderService, $state, reset, purchasingAccounts, customerIntegrationsService) {
    this.name = 'savePurchasingAccounts';
    this.modalLoaderService = modalLoaderService;
    this.purchasingAccounts = purchasingAccounts;
    this.reset = reset;
    this.$state = $state;
    this.customerIntegrationsService = customerIntegrationsService;
    this.isRequestCompleted = false;
    this.isRequestFailure = false;
    this.hasUserConfirmed = false;
    this.showBtn = false;
  }

  cancel() {
    this.reset();
    this.modalLoaderService.close();
  }

  onSavePurchasingAccountsSuccess() {
    this.isRequestCompleted = true;
    const customer = Object.assign({}, this.$state.params.customer, {
      isCreated: false
    });
    if (this.$state.params.customer.isCreated) {
      this.$state.go('home.tools', {
        customer
      });
    }
  }

  onSavePurchasingAccountsFailure() {
    this.isRequestFailure = true;
  }

  confirmSavePurchasingAccount() {
    const save = [];
    if (this.purchasingAccounts.customerIntegrationsToAdd && this.purchasingAccounts.customerIntegrationsToAdd.length || this.purchasingAccounts.removePurchasingAccounts && this.purchasingAccounts.removePurchasingAccounts.length) {
      if (this.purchasingAccounts.customerIntegrationsToAdd && this.purchasingAccounts.customerIntegrationsToAdd.length) {
        save.push(this.customerIntegrationsService.addCustomerIntegrations(this.purchasingAccounts.customer.id, this.purchasingAccounts.customerIntegrationsToAdd));
      }
      if (this.purchasingAccounts.removePurchasingAccounts && this.purchasingAccounts.removePurchasingAccounts.length) {
        save.push(this.customerIntegrationsService.unassignByPurchasingAccountNumbers(this.purchasingAccounts.customer.id, this.purchasingAccounts.removePurchasingAccounts));
      }
      Promise.all(save).then(
        this.onSavePurchasingAccountsSuccess.bind(this),
        this.onSavePurchasingAccountsFailure.bind(this)
      );
    }
  }


}




savePurchasingAccountsController.$inject = ['modalLoaderService', '$state','reset', 'purchasingAccounts', 'customerIntegrationsService'];

export
default savePurchasingAccountsController;



// WEBPACK FOOTER //
// ./app/components/savePurchasingAccounts/savePurchasingAccounts.controller.js